import { useState, useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { Phone, Menu, X } from "lucide-react";

const PHONE = "(67) 99650-8622";
const WHATSAPP_URL = "https://wa.me/5567996508622?text=Ol%C3%A1%2C%20preciso%20de%20um%20guincho!";
const TEL_URL = "tel:+5567996508622";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_372d2d44-3a54-4a7a-9e26-4e2b8f432aad/artifacts/baaqn7xs_ChatGPT%20Image%2016%20de%20abr.%20de%202026%2C%2006_16_22.png";

const NAV_LINKS = [
  { label: "Inicio", href: "#hero" },
  { label: "Sobre", href: "#sobre" },
  { label: "Servicos", href: "#servicos" },
  { label: "Galeria", href: "#galeria" },
  { label: "Avaliacoes", href: "#avaliacoes" },
  { label: "Localizacao", href: "#localizacao" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-black/95 backdrop-blur-md border-b border-[#27272A]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <a href="#hero" className="flex items-center gap-3" data-testid="header-logo">
            <img
              src={LOGO_URL}
              alt="Huck Guincho 24HS"
              className="h-10 sm:h-14 w-auto"
            />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm font-medium text-gray-300 hover:text-[#FFD700] transition-colors uppercase tracking-wider"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTAs */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href={TEL_URL}
              data-testid="header-phone-button"
              className="flex items-center gap-2 text-sm font-bold text-white hover:text-[#FFD700] transition-colors"
            >
              <Phone className="w-4 h-4" />
              {PHONE}
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="header-whatsapp-button"
              className="flex items-center gap-2 bg-[#25D366] hover:bg-[#20BD5A] text-white text-sm font-bold px-4 py-2 rounded-sm transition-colors"
            >
              <FaWhatsapp className="w-4 h-4" />
              WhatsApp
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setMenuOpen(!menuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div
          className="lg:hidden bg-black/98 backdrop-blur-xl border-t border-[#27272A] animate-fade-in"
          data-testid="mobile-menu"
        >
          <div className="px-4 py-6 space-y-4">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="block text-base font-medium text-gray-300 hover:text-[#FFD700] transition-colors uppercase tracking-wider"
              >
                {link.label}
              </a>
            ))}
            <div className="pt-4 flex flex-col gap-3 border-t border-[#27272A]">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-[#25D366] text-white font-bold py-3 rounded-sm"
              >
                <FaWhatsapp className="w-5 h-5" />
                Chamar no WhatsApp
              </a>
              <a
                href={TEL_URL}
                className="flex items-center justify-center gap-2 bg-[#FFD700] text-black font-bold py-3 rounded-sm"
              >
                <Phone className="w-5 h-5" />
                Ligar Agora
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
